/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    object, shape, func, number, arrayOf, bool, string,
} from 'prop-types';
import { withRouter } from 'react-router';
import Media from 'react-media';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { bindActionCreators } from 'redux';
import { format } from 'date-fns';
import AutoRenewal from './AutoRenewal';
import CUSTOM_BREAKPOINTS from '../../../style/customBreakpoints';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getPassportPageUrl, getDeviceType } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import AccountHome from '../../MyAccount/AccountHome';
import { getPassportData } from '../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import validatePassport from '../../../../../helpers/validatePassport';
import { updateUserProfileDetails } from '../../../../../../state/ducks/Member/ducks/Profile/Profile-Actions';
import useGetAccessTokenSafely from '../../../../../gql/hooks/useGetAccessTokenSafely';
import { setTokenLocalStorage } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    root: {
        display: 'block',

        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            display: 'flex',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    headerButton: {
        // overwrite default button styles
        cursor: 'pointer',
        fontSize: '14px !important',
        fontWeight: '700 !important',
        textTransform: 'uppercase',
        textDecoration: 'underline !important',
        color: '#000 !important',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        padding: '5px 10px !important',
        borderRadius: '50px !important',
        marginRight: '0 !important',
        '&:hover': {
            boxShadow: '-2px -2px 5px #fff, 2px 2px 5px #babecc !important',
            textDecoration: 'none !important',
        },
        '&:active': {
            boxShadow: 'inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff !important',
            textDecoration: 'none !important',
        },
    },
    block: {
        border: 'none',
        width: '100%',

        [theme.breakpoints.up('md')]: {
            boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
            margin: '40px 11px 0 43px',
            width: '900px',
        },
    },
    blockHeader: {
        backgroundColor: 'rgba(234, 234, 234, 1)',
        padding: '5px 20px',

    },
    link: {
        display: 'flex',
        alignItems: 'center',
    },
    blockHeading: {
        textTransform: 'uppercase',
    },
    linkText: {
        marginBottom: '0px !important',
        fontSize: '1rem !important',
    },
    blockBody: {
        margin: '20px 10px',
    },
    col: {
        flex: 1,
        letterSpacing: '0.4px',
    },
    col2: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        letterSpacing: '0.4px',

        [theme.breakpoints.up('md')]: {
            marginTop: '4px',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        },
    },
    entry: {
        margin: '7px 20px',
        display: 'block',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            alignItems: 'flex-start',
        },
    },
    entry2: {
        margin: '1px 20px',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
        },

        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    statusEntry: {
        margin: '0px 20px',
        display: 'block',
        marginBottom: '39px',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            alignItems: 'flex-start',
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: '8px 10px',
    },
    centerEntry: {
        textAlign: 'center',
        margin: '15 px 20px',
    },
    boldText: {
        fontWeight: 900,
    },
    boldUpText: {
        fontWeight: 900,
        textTransform: 'uppercase',
        display: 'block',
    },
    greenText: {
        fontWeight: 900,
        color: 'green !important',
    },
    redText: {
        fontWeight: 900,
        color: 'red',
        textAlign: 'center',
    },
    curvedBtn: {
        // overrite default account styles
        backgroundColor: `${theme.palette.cms?.primary} !important` || `${theme.palette.colorPrimary} !important`,
        color: 'white !important',
        border: '0 !important',
        borderRadius: '100px !important',
        padding: '10px 30px !important',
    },
    curvedCheckOutBtn: {
        // overrite default account styles
        backgroundColor: '#600 !important',
        color: 'white !important',
        borderRadius: '100px !important',
        padding: '10px 30px !important',
    },
    focusVisible: {},
    earnBtn: {
        backgroundColor: `${theme.palette.common.black} !important` || '#000000',
        color: theme.palette.common.white || '#FFFFFF',
        border: '0 !important',
        borderRadius: '100px !important',
        padding: '10px 30px !important',
    },
    earnBtnMobile: {
        backgroundColor: `${theme.palette.common.black} !important` || '#000000 !important',
        color: theme.palette.common.white || '#FFFFFF',
        border: '0 !important',
        borderRadius: '100px !important',
        textDecoration: 'none',
        padding: '2px 17px',
        fontSize: '10px !important',
        textAlign: 'center',
        lineHeight: 'normal',
    },
});

const breakpointExpr = `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;

const Passport = ({
    classes,
    userDetails,
    handleSubscriptionRenewal,
    passportInCart,
    handleCheckout,
    featureFlags,
    userProfile,
    fetchPassportAutoRenewalStatus,
    autoRenewalStatus,
    updatePassportAutoRenewalStatus,
    daysDifference,
    statusUpdateError,
    autoRenewalStatusError,
    trackPassportEvent,
    updatedAutoRenewFlag,
    setPassportAutoRenewalStatus,
    passportPageUrl,
    deviceType,
    history,
    passportData,
    cancelPassportMembership,
    cancelPassportMembershipStatus,
    cancelPassportMembershipStatusError,
    clearCancelPassportMembershipState,
    updateUserProfile,
}) => {
    const [cancelPassportMembershipModal, setCancelPassportMembershipModal] = React.useState(false);
    const [cancelPassportMembershipError, setCancelPassportMembershipError] = React.useState(false);
    const [cancelPassportMembershipSuccess, setCancelPassportMembershipSuccess] = React.useState(false);
    const [isAutoRenewDisabled, setIsAutoRenewDisabled] = React.useState(false);
    const [autoRenewError, setAutoRenewError] = React.useState(false);
    const [renderStatus, setRenderStatus] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const isDesktop = deviceType === 'desktop';
    const jwt = useGetAccessTokenSafely();

    if (!renderStatus && autoRenewalStatus?.isAutoRenew === undefined) {
        fetchPassportAutoRenewalStatus(userDetails.email);
        setRenderStatus(true);
    }

    const isCancelledPassport = () => {
        if (autoRenewalStatus?.cancellationDate && userProfile?.passportFlag === '01-03') return true;
        return false;
    };

    useEffect(() => {
        let status;
        if (updatedAutoRenewFlag?.autoRenewFlag === undefined) {
            status = autoRenewalStatus?.isAutoRenew;
        } else {
            status = updatedAutoRenewFlag?.autoRenewFlag;
        }
        if (status === undefined || (typeof status === 'string')) return;

        setPassportAutoRenewalStatus({ ...autoRenewalStatus, isAutoRenew: status });
    }, [updatedAutoRenewFlag?.autoRenewFlag]);

    useEffect(() => {
        // If passport expiration date is due in 2 days or failed to get auto renew status, hide auto renew feature
        if (daysDifference >= -2 || autoRenewalStatusError) setIsAutoRenewDisabled(true);
        // if auto renew update failed, render error message
        if (statusUpdateError) {
            setAutoRenewError(true);
            trackPassportEvent({
                eventCategory: 'account',
                eventAction: 'pp auto renew failure',
                eventLabel: 'passport',
                eventValue: 1,
            });
        }
    }, [statusUpdateError, autoRenewalStatusError]);

    useEffect(() => {
        setIsLoading(false);
        if (cancelPassportMembershipStatusError !== '') setCancelPassportMembershipError(true);
        if (cancelPassportMembershipStatus.result?.includes('success')) {
            const canceledPassportUser = {
                token: jwt,
                profile: {
                    ...userProfile, passportFlag: '01-03', membershipType: 'R', userRole: '',
                },
            };
            fetchPassportAutoRenewalStatus(userDetails.email);
            setCancelPassportMembershipSuccess(true);
            updateUserProfile(canceledPassportUser);
            setCancelPassportMembershipError(false);
            trackPassportEvent({
                eventCategory: 'account',
                eventAction: 'passport cancelled',
                eventLabel: 'passport',
            });
            setTimeout(() => {
                setCancelPassportMembershipModal(false);
            }, 3000);
            setTokenLocalStorage(true, 'refreshMetadata');
        }
    }, [cancelPassportMembershipStatus, cancelPassportMembershipStatusError]);

    const handleCPMModalClose = () => {
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'closeed pp cancellation modal',
            eventLabel: 'passport',
        });
        setCancelPassportMembershipModal(false);
        setCancelPassportMembershipError(false);
        clearCancelPassportMembershipState();
    };

    const handleCancelMembership = () => {
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'clicked on Yes, Cancel',
            eventLabel: 'passport',
        });
        setIsLoading(true);
        clearCancelPassportMembershipState();
        setCancelPassportMembershipError(false);
        cancelPassportMembership({ emailId: userProfile.email, contactId: userProfile.contactId });
    };

    const handleCancelPpBtn = () => {
        setCancelPassportMembershipModal(true);
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'clicked on Cancel Membership',
            eventLabel: 'passport',
        });
    };

    let passport_item;
    let cta_copy = '';
    const pp_copy = (message, price) => message?.replace('{passport_price}', `$${price}`) || '';

    if (featureFlags['is-renew-early-pricing-on'] && validatePassport('isExpiringPassportUser', passportData)) { // passport membership about to exprire
        passport_item = passportData?.myaccount_passport?.renew_early_button_passport_price?.passport_referenced_sku?.[0];
        cta_copy = passportData?.myaccount_passport?.renew_early_button_passport_price?.cta_copy || '';
    } else if (featureFlags['is-renew-early-pricing-on'] && validatePassport('isExpiredPassportUser', passportData)) { // passport membership expired / former member
        passport_item = passportData?.myaccount_passport?.renew_button_passport_price?.passport_referenced_sku?.[0];
        cta_copy = passportData?.myaccount_passport?.renew_button_passport_price?.cta_copy || '';
    }

    let membershipRenewalButton = cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew';
    let memberShipStatus = <p className={classes.redText}>&nbsp; Inactive</p>;
    if (userDetails?.isActive) {
        membershipRenewalButton =  cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew Early';
        memberShipStatus = <p className={classes.greenText}>&nbsp; Active</p>;
    }
    if (isCancelledPassport()) {
        membershipRenewalButton =  cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew';
        memberShipStatus = <p className={classes.redText}>&nbsp; Inactive</p>;
    }

    return (
        <>
            <div className={classes.root}>
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <h1>
                                <AccountHome />
                                Passport
                            </h1>
                        )
                            : (
                                <AccountLeftMenu
                                    userProfile={userProfile}
                                    featureFlags={featureFlags}
                                />
                            )
                    )}
                </Media>
                <div className={classes.block}>
                    <div className={classes.blockHeader}>
                        <div className={classes.headerContainer}>
                            <h3 className={classes.blockHeading}>Membership Details</h3>
                            {
                                featureFlags['is-passport-cancel-button-on'] && !isCancelledPassport() && !validatePassport('isExpiredPassportUser', passportData) && (
                                    <button type="button" onClick={handleCancelPpBtn} className={classes.headerButton}>
                                        Cancel Membership
                                    </button>
                                )
                            }
                        </div>
                    </div>
                    <div className={classes.blockBody}>
                        <div className={classes.container}>
                            <div className={classes.col}>
                                <div className={classes.entry}>
                                    <p className={classes.boldText}>Member Email:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.email}</p>
                                </div>
                                <div className={classes.entry}>
                                    <p className={classes.boldText}>Member Since:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.memberSince}</p>
                                </div>
                            </div>
                            <div className={classes.col2}>
                                <div className={classes.entry2}>
                                    <p className={classes.boldText}>Membership Start Date:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.startDate}</p>
                                    {featureFlags['is-yotpo-earn-rewards-btn-enabled']
                                        && (
                                            <div className={classes.buttonContainer}>
                                                <Button
                                                    className={isDesktop ? classes.earnBtn : classes.earnBtnMobile}
                                                    onClick={() => history.push(passportPageUrl)}
                                                >
                                                    Earn Rewards
                                                </Button>
                                            </div>
                                        )}
                                </div>
                                <div className={classes.entry2}>
                                    <p className={classes.boldText}>{isCancelledPassport() ? 'Membership Cancelation Date:' : 'Membership End Date'}</p>
                                    <p className={classes.text}>&nbsp;{isCancelledPassport() ? format(new Date(autoRenewalStatus?.cancellationDate), 'MMMM d, yyyy') : userDetails?.endDate}</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.container}>
                            <div className={classes.col}>
                                <div className={classes.statusEntry}>
                                    <p className={classes.boldText}>Status:</p>
                                    {memberShipStatus}
                                </div>
                                {userDetails?.message && (
                                    <p className={`${classes.redText} ${userDetails?.successMsg ? classes.greenText : ''}`}>
                                        {userDetails.message}
                                    </p>
                                )}
                                <div className={classes.container}>
                                    <div className={classes.col2}>
                                        <div className={classes.buttonContainer}>
                                            {(userDetails?.showRenewalBtn || isCancelledPassport())
                                                && (passportInCart.length < 1
                                                    ? (
                                                        <Button
                                                            className={classes.curvedBtn}
                                                            onClick={() => handleSubscriptionRenewal(passport_item?.passport_item_sku)}
                                                        >
                                                            {membershipRenewalButton}
                                                        </Button>
                                                    )
                                                    : (
                                                        <Button
                                                            color="buttonHDSecondary"
                                                            className={classes.curvedCheckOutBtn}
                                                            onClick={handleCheckout}
                                                        >
                                                            Go To Checkout
                                                        </Button>
                                                    ))}
                                        </div>
                                        <div className={classes.buttonContainer}>
                                            {featureFlags['is-passport-autorenew-button-on'] && !isAutoRenewDisabled && !isCancelledPassport() && (
                                                <AutoRenewal
                                                    userDetails={userDetails}
                                                    autoRenewalStatus={autoRenewalStatus?.isAutoRenew}
                                                    updateAutoRenewal={updatePassportAutoRenewalStatus}
                                                    statusUpdateError={statusUpdateError}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {autoRenewError
                                && (
                                    <span className={classes.redText}>
                                        There was an error while updating your auto renewal status. Please contact our customer service at 1-800-716-4851.
                                    </span>
                                )}
                        </div>
                        {/* <div className={classes.centerEntry}>
                            <span>
                                *Your default card will be used for Passport membership renewals.
                            </span>
                        </div> */}
                    </div>
                </div>
            </div>
            {cancelPassportMembershipModal && <CancelSubscriptionModal isLoading={isLoading} cancelPassportMembershipSuccess={cancelPassportMembershipSuccess} cancelPassportMembership={handleCancelMembership} cancelPassportMembershipError={cancelPassportMembershipError} close={handleCPMModalClose} open={cancelPassportMembershipModal} />}
        </>
    );
};

Passport.defaultProps = {
    passportInCart: [],
    handleCheckout: () => { },
    featureFlags: shape({
        'is-passport-cancel-button-on': bool,
        'is-passport-autorenew-button-on': bool,
        'is-yotpo-earn-rewards-btn-enabled': bool,
    }),
    userDetails: shape({
        email: string,
        memberSince: number,
        startDate: string,
        endDate: string,
        renewalDate: string,
        showRenewalBtn: bool,
        isActive: bool,
        message: string,

    }),
    userProfile: {},
    fetchPassportAutoRenewalStatus: () => { },
    updatePassportAutoRenewalStatus: () => { },
    cancelPassportMembership: () => { },
    clearCancelPassportMembershipState: () => { },
    updateUserProfile: () => { },
    cancelPassportMembershipStatus: {},
    cancelPassportMembershipStatusError: '',
    autoRenewalStatus: {},
    daysDifference: number,
    statusUpdateError: '',
    autoRenewalStatusError: '',
    setPassportAutoRenewalStatus: () => { },
    updatedAutoRenewFlag: {},
    passportData: {},
};

Passport.propTypes = {
    classes: object.isRequired,
    history: object.isRequired,
    handleSubscriptionRenewal: func.isRequired,
    passportInCart: arrayOf(shape({
        cartItems: arrayOf(shape({
            ordersId: number,
        })),
    })),
    handleCheckout: func,
    featureFlags: {},
    userDetails: {},
    userProfile: {},
    fetchPassportAutoRenewalStatus: func,
    updatePassportAutoRenewalStatus: func,
    autoRenewalStatus: object,
    cancelPassportMembership: func,
    updateUserProfile: func,
    cancelPassportMembershipStatus: object,
    clearCancelPassportMembershipState: object,
    cancelPassportMembershipStatusError: string,
    daysDifference: number,
    statusUpdateError: string,
    autoRenewalStatusError: string,
    trackPassportEvent: func.isRequired,
    setPassportAutoRenewalStatus: func,
    updatedAutoRenewFlag: object,
    passportPageUrl: string.isRequired,
    deviceType: string.isRequired,
    passportData: {},
};

const mapDispatchToProps = (dispatch) => ({
    fetchPassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.handleFetchPassportAutoRenewalStatus(payload)),
    updatePassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.updatePassportAutoRenewalStatus(payload)),
    cancelPassportMembership: (payload) => dispatch(EventDispatcher.cancelPassportMembership(payload)),
    clearCancelPassportMembershipState: () => dispatch(EventDispatcher.clearCancelPassportMembershipState()),
    trackPassportEvent: bindActionCreators(track, dispatch),
    setPassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.setPassportAutoRenewalStatus(payload)),
    updateUserProfile: (payload) => dispatch(updateUserProfileDetails(payload)),
});

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        autoRenewalStatus: newState?.autoRenewalStatus,
        autoRenewalStatusError: newState?.autoRenewalStatusError,
        cancelPassportMembershipStatus: newState?.cancelPassportMembershipStatus,
        cancelPassportMembershipStatusError: newState?.cancelPassportMembershipStatusError,
        statusUpdateError: newState?.statusUpdateError,
        updatedAutoRenewFlag: newState?.data,
        passportPageUrl: getPassportPageUrl(state),
        deviceType: getDeviceType(state),
        passportData: getPassportData(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(Passport)));
